import { render, staticRenderFns } from "./NotificationAccordion.vue?vue&type=template&id=e9eb081a&scoped=true&"
import script from "./NotificationAccordion.vue?vue&type=script&lang=js&"
export * from "./NotificationAccordion.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAccordion.vue?vue&type=style&index=0&id=e9eb081a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9eb081a",
  null
  
)

export default component.exports